import { baseElements } from '../helpers/constants';
import { addClass, removeClass, getElement, getElements, toggleClass } from '../helpers/functions';
import SlideMenu from '../vendors/menu/SlideMenu';
import { getScroll } from '../vendors/smooth-scroll';
const {
  $header
} = baseElements;
const lenis = getScroll();
let currentTransformValue = 0;
let startPoint = null;
let headerHeight = $header.offsetHeight || 175;
const isKeyvisualOnPage = getElement('.ce-keyvisual');
const scrollUp = () => {
  currentTransformValue = 0;
  startPoint = null;
  addClass($header, '_up');
  removeClass($header, '_down');
};
const scrollDown = scrollPos => {
  if (!startPoint) startPoint = scrollPos;
  if (currentTransformValue < headerHeight) {
    currentTransformValue = scrollPos - startPoint;
    removeClass($header, '_up');
    addClass($header, '_down');
  }
};
const onScroll = (scrollPos, direction) => {
  toggleClass($header, '_sticky', direction === -1 && scrollPos > 0);
  toggleClass($header, '_inverted', scrollPos > 10);
};
const header = () => {
  lenis.on('scroll', e => {
    const {
      direction,
      scroll
    } = e;
    if (direction === 1) {
      scrollDown(scroll);
    } else {
      scrollUp(scroll);
    }
    onScroll(scroll, direction);
  });
  toggleClass($header, '_non-transparent', !isKeyvisualOnPage);
  const menuElement = getElement('#slide-menu');
  const toggleBtn = getElement('.slide-menu--control', $header);
  const navItems = getElements('[data-navigate]', $header);
  const desktopMegaMenu = getElement('#desktop-mega-menu');
  const desktopMegaTriggers = getElements('[data-mega-root]', $header);
  const searchPanel = getElement('.search-panel', $header);
  const searchToggleBtn = getElement('.search-panel--trigger', $header);
  const searchToggleBtnMobile = getElement('.search-panel--trigger-mobile');
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  const menu = new SlideMenu(menuElement, {
    position: 'left',
    saveMenuState: false,
    showTitle: false,
    showBackLink: false,
    backLinkBefore: '<span class="icon icon-arrow-left-icon"></span>',
    // Submenu navigation uses dedicated, accessible buttons in the template.
    submenuLinkAfter: '',
    onOpen: () => lenis.stop(),
    onClose: () => lenis.start()
  });
  const mobileMenuMedia = window.matchMedia('(max-width: 991.98px)');
  const mobilePanelStack = [];
  const getDirectSubmenu = item => item?.querySelector(':scope > .slide-menu__list');

  /*
   * ============================================================
   * LEVEL 2 ACCORDION
   * ============================================================
   */

  const closeAccordionItem = item => {
    if (!item) return;
    const toggle = item.querySelector(':scope > .slide-menu__submenu-toggle.__accordion');
    const submenu = getDirectSubmenu(item);
    removeClass(item, '__submenu-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
    if (submenu) {
      submenu.setAttribute('aria-hidden', 'true');
    }
  };
  const closeMobileAccordions = function () {
    let exceptItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    getElements('.__first > .slide-menu__list-item.__submenu-open', menuElement).forEach(item => {
      if (item !== exceptItem) {
        closeAccordionItem(item);
      }
    });
  };
  const setAccordionItem = (item, open) => {
    if (!item) return;
    const toggle = item.querySelector(':scope > .slide-menu__submenu-toggle.__accordion');
    const submenu = getDirectSubmenu(item);
    if (!toggle || !submenu) return;
    if (open) {
      closeMobileAccordions(item);
    }
    toggleClass(item, '__submenu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    submenu.setAttribute('aria-hidden', String(!open));
  };

  /*
   * ============================================================
   * LEVEL 3+ PANELS
   * ============================================================
   */

  const closeMobilePanel = panel => {
    if (!panel) return;
    removeClass(panel, '__mobile-panel-open');
    panel.setAttribute('aria-hidden', 'true');
    panel.style.removeProperty('z-index');
    const ownerItem = panel.parentElement;
    const toggle = ownerItem?.querySelector(':scope > .slide-menu__submenu-toggle.__panel');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
    const panelIndex = mobilePanelStack.indexOf(panel);
    if (panelIndex !== -1) {
      mobilePanelStack.splice(panelIndex, 1);
    }
  };
  const closeAllMobilePanels = () => {
    [...mobilePanelStack].reverse().forEach(panel => {
      closeMobilePanel(panel);
    });
    getElements('.slide-menu__list.__mobile-panel-open', menuElement).forEach(panel => {
      closeMobilePanel(panel);
    });
  };
  const openMobilePanel = (panel, toggle) => {
    if (!panel || !toggle) return;
    if (!panel.classList.contains('__mobile-panel')) {
      addClass(panel, '__mobile-panel');
    }
    const existingIndex = mobilePanelStack.indexOf(panel);
    if (existingIndex !== -1) {
      mobilePanelStack.splice(existingIndex, 1);
    }
    mobilePanelStack.push(panel);
    panel.style.zIndex = String(20 + mobilePanelStack.length);
    panel.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(() => {
      addClass(panel, '__mobile-panel-open');
      panel.scrollTop = 0;
    });
  };

  /*
   * ============================================================
   * INITIAL MOBILE STATE
   * ============================================================
   */

  getElements('.__first > .slide-menu__list-item > .slide-menu__submenu-toggle.__accordion', menuElement).forEach(toggle => {
    const item = toggle.parentElement;
    const submenu = getDirectSubmenu(item);
    if (submenu) {
      submenu.setAttribute('aria-hidden', 'true');
    }
  });
  getElements('.slide-menu__submenu-toggle.__panel', menuElement).forEach(toggle => {
    const item = toggle.parentElement;
    const panel = getDirectSubmenu(item);
    if (panel) {
      addClass(panel, '__mobile-panel');
      panel.setAttribute('aria-hidden', 'true');
    }
  });

  /*
   * ============================================================
   * MOBILE CLICK HANDLING
   * ============================================================
   *
   * Level 1 -> Level 2:
   * accordion
   *
   * Level 2 -> Level 3+:
   * slide panel
   */

  menuElement.addEventListener('click', event => {
    if (!mobileMenuMedia.matches) {
      return;
    }

    /*
     * Nasza strzałka.
     */
    const submenuToggle = event.target.closest('.slide-menu__submenu-toggle');
    if (submenuToggle && menuElement.contains(submenuToggle)) {
      const item = submenuToggle.parentElement;
      const submenu = getDirectSubmenu(item);
      if (!item || !submenu) {
        return;
      }
      event.preventDefault();

      /*
       * Blokujemy listener SlideMenu.
       */
      event.stopImmediatePropagation();

      /*
       * LEVEL 1 -> LEVEL 2
       */
      if (submenuToggle.classList.contains('__accordion')) {
        const willOpen = !item.classList.contains('__submenu-open');
        setAccordionItem(item, willOpen);
        return;
      }

      /*
       * LEVEL 2 -> LEVEL 3+
       */
      if (submenuToggle.classList.contains('__panel')) {
        openMobilePanel(submenu, submenuToggle);
      }
      return;
    }

    /*
     * BACK w level 3+.
     */
    const backButton = event.target.closest('.slide-menu__list.__mobile-panel .slide-menu__backlink[data-action="back"]');
    if (backButton && menuElement.contains(backButton)) {
      const panel = backButton.closest('.slide-menu__list.__mobile-panel');
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMobilePanel(panel);
      return;
    }

    /*
     * Kliknięcie tekstu parenta nie może
     * uruchamiać starego forward SlideMenu.
     *
     * Link pozostaje normalnym linkiem.
     * Submenu otwiera tylko strzałka.
     */
    const parentLink = event.target.closest('.slide-menu__list-item.__has-subpage > .slide-menu__link');
    if (parentLink && menuElement.contains(parentLink)) {
      event.stopImmediatePropagation();
    }
  }, true);
  mobileMenuMedia.addEventListener('change', event => {
    closeMobileAccordions();
    closeAllMobilePanels();
    if (!event.matches) {
      getElements('.slide-menu__list.__mobile-panel', menuElement).forEach(panel => {
        panel.removeAttribute('aria-hidden');
      });
    }
  });

  /*
   * ============================================================
   * HEADER NAVIGATION
   * ============================================================
   */

  navItems.forEach(el => {
    el.addEventListener('click', e => {
      const linkId = e.currentTarget.dataset.navigate || e.target.dataset.navigate;
      const targetLink = linkId ? getElement(`#${linkId}`, menuElement) : null;
      const targetItem = targetLink?.closest('.slide-menu__list-item');
      const activeLink = getDirectSubmenu(targetItem);
      if (!activeLink) return;
      menu.open();
      if (mobileMenuMedia.matches && targetItem?.parentElement?.classList.contains('__first')) {
        setAccordionItem(targetItem, true);
      } else {
        menu.navigateTo(activeLink);
      }
      e.preventDefault();
    });
  });

  /*
   * ============================================================
   * DESKTOP MEGA MENU
   * ============================================================
   */

  if (desktopMegaMenu) {
    const megaBranches = getElements('.desktop-mega-menu__branch', desktopMegaMenu);
    const megaLeafItems = getElements('.desktop-mega-menu__column > .desktop-mega-menu__item', desktopMegaMenu);
    const megaHeadings = getElements('.desktop-mega-menu__heading', desktopMegaMenu);
    const megaPanels = getElements('[data-mega-panel]', desktopMegaMenu);
    let megaPath = [];
    let opaqueMegaPanels = [];
    const renderMegaPath = () => {
      const visiblePanels = megaPath.slice(-3);
      megaPanels.forEach(panel => {
        const panelIndex = visiblePanels.indexOf(panel.dataset.megaPanel);
        panel.classList.toggle('__visible', panelIndex !== -1);
        panel.classList.toggle('__first-visible', panelIndex === 0);
        panel.classList.toggle('__last-visible', visiblePanels.length === 3 && panelIndex === visiblePanels.length - 1);
        panel.classList.toggle('__opaque', panelIndex === 0 || opaqueMegaPanels.includes(panel.dataset.megaPanel));
      });
      megaBranches.forEach(item => {
        const selected = megaPath.includes(item.dataset.megaTarget);
        item.parentElement.classList.toggle('__selected', selected);
        item.setAttribute('aria-expanded', selected.toString());
      });
      desktopMegaMenu.dataset.megaDepth = String(visiblePanels.length);
    };
    const closeMega = () => {
      desktopMegaMenu.classList.remove('__open');
      desktopMegaMenu.setAttribute('aria-hidden', 'true');
      desktopMegaTriggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      megaPath = [];
      opaqueMegaPanels = [];
      renderMegaPath();
    };
    const closeMegaChildren = () => {
      // Keep the root column open, but discard every level opened by an arrow.
      megaPath = megaPath.slice(0, 1);
      opaqueMegaPanels = opaqueMegaPanels.filter(panelId => megaPath.includes(panelId));
      renderMegaPath();
    };
    const openMega = rootId => {
      desktopMegaMenu.classList.add('__open');
      desktopMegaMenu.setAttribute('aria-hidden', 'false');
      desktopMegaTriggers.forEach(trigger => {
        trigger.setAttribute('aria-expanded', (trigger.dataset.megaRoot === rootId).toString());
      });
      megaPath = [rootId];
      opaqueMegaPanels = [rootId];
      renderMegaPath();
    };
    desktopMegaTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        if (desktopMegaMenu.classList.contains('__open') && trigger.getAttribute('aria-expanded') === 'true') {
          closeMega();
        } else {
          openMega(trigger.dataset.megaRoot);
        }
      });
    });
    megaBranches.forEach(item => {
      const openBranch = () => {
        const parentIndex = megaPath.indexOf(item.dataset.megaParent);
        megaPath = [...megaPath.slice(0, parentIndex + 1), item.dataset.megaTarget];
        opaqueMegaPanels = opaqueMegaPanels.filter(panelId => megaPath.includes(panelId) && panelId !== item.dataset.megaTarget);
        renderMegaPath();
      };
      const entry = item.closest('.desktop-mega-menu__entry');
      entry.addEventListener('mouseenter', openBranch);
      entry.addEventListener('focusin', openBranch);

      // Keep the button operable for keyboard and touch input.
      item.addEventListener('click', openBranch);
    });
    megaLeafItems.forEach(item => {
      const closeChildBranch = () => {
        const panel = item.closest('[data-mega-panel]');
        const panelIndex = megaPath.indexOf(panel?.dataset.megaPanel);
        if (panelIndex === -1) return;
        megaPath = megaPath.slice(0, panelIndex + 1);
        opaqueMegaPanels = opaqueMegaPanels.filter(panelId => megaPath.includes(panelId));
        renderMegaPath();
      };
      item.addEventListener('mouseenter', closeChildBranch);
      item.addEventListener('focusin', closeChildBranch);
    });
    megaHeadings.forEach(heading => {
      const closeChildBranches = () => {
        const panel = heading.closest('[data-mega-panel]');
        const panelIndex = megaPath.indexOf(panel?.dataset.megaPanel);
        if (panelIndex === -1) return;
        megaPath = megaPath.slice(0, panelIndex + 1);
        opaqueMegaPanels = opaqueMegaPanels.filter(panelId => megaPath.includes(panelId));
        renderMegaPath();
      };
      heading.addEventListener('mouseenter', closeChildBranches);
      heading.addEventListener('focusin', closeChildBranches);
    });
    megaPanels.forEach(panel => {
      const makePanelOpaque = () => {
        if (!megaPath.includes(panel.dataset.megaPanel) || opaqueMegaPanels.includes(panel.dataset.megaPanel)) return;
        opaqueMegaPanels.push(panel.dataset.megaPanel);
        renderMegaPath();
      };
      panel.addEventListener('mouseenter', makePanelOpaque);
      panel.addEventListener('focusin', makePanelOpaque);
    });
    desktopMegaMenu.addEventListener('mouseleave', closeMegaChildren);
    desktopMegaMenu.addEventListener('click', event => {
      if (event.target === desktopMegaMenu) {
        closeMega();
      }
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        closeMega();
      }
    });
    document.addEventListener('click', event => {
      if (!desktopMegaMenu.contains(event.target) && !$header.contains(event.target)) {
        closeMega();
      }
    });
  }

  /*
   * ============================================================
   * GENERAL
   * ============================================================
   */

  window.addEventListener('windowResize', () => {
    headerHeight = $header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  });
  document.addEventListener('click', e => {
    if (e.target.matches('body') && menu) {
      menu.close();
    }
  });
  toggleBtn.addEventListener('click', () => {
    if (menu !== null) {
      menu.toggle();
    }
  });
  menuElement.addEventListener('sm.open', () => {
    addClass(toggleBtn, '__close');
  });
  menuElement.addEventListener('sm.close', () => {
    removeClass(toggleBtn, '__close');
    closeMobileAccordions();
    closeAllMobilePanels();
  });
  menuElement.addEventListener('sm.forward', e => {
    e.target.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });

  /*
   * ============================================================
   * SEARCH
   * ============================================================
   */

  searchToggleBtn.addEventListener('click', () => {
    toggleClass(searchToggleBtn, '__menu-opened');
    toggleClass(searchPanel, '__open');
  });
  searchToggleBtnMobile.addEventListener('click', () => {
    toggleClass(searchToggleBtn, '__menu-opened');
    toggleClass(searchPanel, '__open');
    if (menu !== null) {
      menu.close();
    }
  });
};
export default header;